export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const SET_TARGET_ROUTE = 'SET_TARGET_ROUTE'
export const RUN_TRANSITION = 'RUN_TRANSITION'
export const SET_INITIAL_LOAD = 'SET_INITIAL_LOAD'
